import { Clock } from '#packages/data-collection/services/clock';

export const clock = new Clock();
